import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Tell Us About Your Business",
    text: "Share your business details, goals, and preferences in a short, simple conversation.",
    id: "step-1",
  },
  {
    n: "02",
    title: "We Create Your Website",
    text: "We design and build your professional website, then incorporate your feedback.",
    id: "step-2",
  },
  {
    n: "03",
    title: "We Launch & Maintain It",
    text: "Your website goes live, and we handle ongoing hosting and care.",
    id: "step-3",
  },
];

const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="relative bg-charcoal py-20 md:py-28 lg:py-32 overflow-hidden"
  >
    <div className="noise-overlay" aria-hidden="true" />
    <div
      className="absolute -bottom-48 -left-48 w-[600px] h-[600px] rounded-full bg-turquoise/10 blur-[160px] pointer-events-none"
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-champagne mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-turquoise inline-block" />
          How It Works
        </p>
        <h2 className="font-serif font-medium tracking-tight text-cream text-2xl sm:text-3xl lg:text-4xl leading-tight">
          Three easy steps. <span className="italic text-turquoise">Zero headaches.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.12}>
            <div data-testid={`how-${s.id}`} className="relative border-t border-champagne/15 pt-8">
              <span
                className="font-serif text-7xl lg:text-8xl leading-none text-transparent select-none"
                style={{ WebkitTextStroke: "1px rgba(232,198,160,0.35)" }}
                aria-hidden="true"
              >
                {s.n}
              </span>
              <h3 className="mt-5 font-serif font-medium text-xl sm:text-2xl text-cream leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 font-sans text-sm text-champagne/60 leading-relaxed max-w-xs">
                {s.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
